
import { Component, Vue } from "vue-property-decorator";
import { useAppInsights } from '../../store/modules/AppInsights'
import { mapGetters } from "vuex";

@Component({
  components: {},
  computed: {
    ...mapGetters(["oidcUser"]),
  },
})
export default class InvalidAccount extends Vue {  
  oidcUser!: any;

  constructor() {
    super();
  }

  created(){
  }
}
